__turbopack_context__.v({
  "animate": "_EMzqG_animate",
  "blank": "_EMzqG_blank",
  "changeBg": "_EMzqG_changeBg",
});
